import { Injectable } from "@angular/core";
import { BaseDataService, HttpService } from "./base.service";
import { TsdfCode } from "../..";

@Injectable()
export class TsdfCodeService extends BaseDataService<TsdfCode> {
  constructor(http: HttpService) {
    super(http, "tsdfcode");
  }

  createInstance(options: any): TsdfCode {
    return new TsdfCode(options);
  }

  getActive() {
    return this.http.request(`${this.resourceUrl}/active`);
  }
}
